import { TeamSettingsService } from '../../../core/services/team-settings.service';
import { UserService } from '../../../core/services/user.service';
import useService from '../../../injector/hooks/useService';

export default function useTeamSettings() {
  const teamSettingsService = useService(TeamSettingsService);
  const userService = useService(UserService);

  return {
    getTeamSettingsValue: () => teamSettingsService.getTeamSettingsValue(),
    getTeamSettings: () => teamSettingsService.getTeamSettingsValue(),
    isRBACEnabled: teamSettingsService.isRBACEnabled(),
    isFBAdsSearchEnabled: teamSettingsService.isFBAdsSearchEnabled(),
    isWebhookEventsEnabled: teamSettingsService.isWebhookEventsEnabled(),
    isWorkFlowsEnabled: teamSettingsService.isWorkflowsEnabled(),
    isMongoDbDisplayParseAsStringOptionEnabled: teamSettingsService.isMongoDbDisplayParseAsStringOptionEnabled(),
    isDraftPipelineEnabled: teamSettingsService.isDraftPipelineEnabled(),
    getVPCPeeringConfig: () => teamSettingsService.getVPCPeeringConfig(),
    isHistoricalTaskSeparationForTableModeEnabled: teamSettingsService.isHistoricalTaskSeparationForTableModeEnabled(),
    isServerlessAllowedForTeam: () => teamSettingsService.isServerlessAllowedForTeam(),
    isH2OEnabled: () => teamSettingsService.isH2OEnabled(),
    isPostLoadTransformationEnabled: () => teamSettingsService.isPostLoadTransformationEnabled(),
    isH20BillingEnabled: () => teamSettingsService.isH20BillingEnabled(),
    get isEdgeAsDefaultEnabled() {
      return teamSettingsService.isEdgeAsDefaultEnabled();
    },
    get isWorkspacesEnabled() {
      return teamSettingsService.isWorkspacesEnabled();
    },
    get isISVTeam() {
      return userService.isISVTeam();
    },
    get isWorkspaceTeam() {
      return userService.isWorkspaceTeam();
    },
    isYukiProxyForSnowflakeEnabled: teamSettingsService.isYukiProxyForSnowflakeEnabled(),
    showPubKeyMessageTeam: teamSettingsService.showPubKeyMessageTeam(),
    isPythonTransformationsEnabled: teamSettingsService.isPythonTransformationsEnabled(),
    isCerebraEnabled: teamSettingsService.isCerebraEnabled()
  };
}
